import { AddInsightToCollectionsButton, CreateInsightDataFn, Proposition } from '@ecosystem/newron-client-collections';
import { CollectionButtonProps } from '../collections/Model';
import { PerformanceAnalysisLineChartInsight } from '../collections/performance-analysis-line-chart/Model';
import { getCollectionsAmplitudeTrackingTags } from '../../utils/collectionUtils/CollectionUtils';
import { usePageConfig } from '../../utils/pageConfig/PagesConfigContext';
import { PerformanceAnalysisStackedBarChartInsight } from '../collections/performance-analysis-stacked-bar-chart/Model';

export interface PerformanceAnalysisCollectionButtonProps {
  collectionButtonProps: CollectionButtonProps;
  createInsightDataFn: CreateInsightDataFn<
    PerformanceAnalysisLineChartInsight | PerformanceAnalysisStackedBarChartInsight
  >;
  enableDataType: boolean;
}

const PerformanceAnalysisCollectionButton: React.FC<PerformanceAnalysisCollectionButtonProps> = ({
  createInsightDataFn,
  collectionButtonProps,
  enableDataType,
}) => {
  const pagesConfig = usePageConfig();

  return (
    <AddInsightToCollectionsButton<PerformanceAnalysisLineChartInsight | PerformanceAnalysisStackedBarChartInsight>
      type={collectionButtonProps.type}
      proposition={Proposition.Retail}
      createInsightDataFn={createInsightDataFn}
      selectDataType={enableDataType}
      defaultDataType={'live'}
      getTrackingTags={getCollectionsAmplitudeTrackingTags(pagesConfig)}
    />
  );
};

export default PerformanceAnalysisCollectionButton;
